<template>
  <div>
    <b-card v-if="!isBarCodeStep" :title="$t('warehouse.order-process')">
      <b-card-text>
        <b-row>
          <b-col lg="6">
            <AutoComplete
              v-if="$route.name.includes('hospital')"
              :label="$t('warehouse.reciever')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.reciever'
              )}`"
              v-model="employee_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="employees"
              text-title="full_name"
              
            />
            <AutoComplete
              v-else
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              v-model="patient_card_id"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient`"
              keyword="patient"
            />
            <!-- date picker -->
          </b-col>
          <b-col lg="6">
            <b-form-group :label="$t('common.date')" label-for="Date">
              <datepicker
                v-model="date"
                :calendar-button="true"
                :clear-button="true"
                format="YYYY-MM-DD HH:mm"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD H:i"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-form-group
              :label="$t('common.description')"
              label-for="Description"
            >
              <b-form-textarea
                id="Description"
                v-model="description"
                :placeholder="$t('common.description')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="!showTables" class="d-flex justify-content-end">
          <b-button
            class="mt-2"
            ref="myButton"
            variant="primary"
            @click="isBarCodeStep = true"
          >
            {{ $t('warehouse.scan-barcode') }}
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <b-card v-if="isBarCodeStep">
      <ScanBarcode @barcode="addToItemsList($event)" />
    </b-card>
    <b-card :title="$t('warehouse.item')" v-if="showTables">
      <b-table
        :items="this.items"
        responsive
        :fields="itemsCloumns"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
        v-if="!loading"
      >
        <template #cell(expiry_date)="data">
          <b-badge pill :variant="getBadgeVariant(data.item.expiry_date)">{{
            data.item.expiry_date
          }}</b-badge>
        </template>
        <template #cell(changeable-quantity)="data">
          <b-form-input
            type="number"
            id="Quantity"
            v-model="editableQuantities[data.item.id]"
            :placeholder="$t('warehouse.quantity')"
          />
        </template>
        <template #cell(unit_price)="data">
          <b-form-input
            type="number"
            id="Price"
            v-model="data.item.unit_price"
            :placeholder="$t('warehouse.price')"
          />
        </template>
        <template #cell(actions)="data">
          <b-button
            class="mt-2"
            ref="myButton"
            pill
            size="sm"
            variant="outline-primary"
            @click="addToStockOuts(data.item)"
          >
            {{ $t('common.add') }}
          </b-button>
        </template>
      </b-table>
      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="d-flex justify-content-end">
        <b-button
          class="mt-2"
          ref="myButton"
          variant="warning"
          @click="showScanner"
        >
          {{ $t('warehouse.scan-again') }}
        </b-button>
      </div></b-card
    >

    <b-card v-if="showTables" :title="$t('warehouse.stockout-items')">
      <b-table
        :items="stockouts"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(expiry_date)="data">
          <b-badge pill :variant="getBadgeVariant(data.item.expiry_date)">{{
            data.item.expiry_date
          }}</b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="stockouts.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t('common.submit') }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
  BBadge,
  BFormTextarea,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
const CategoryModal = () => import('@/components/warehouse/CategoryModal.vue');
const ScanBarcode = () => import('@/views/warehouse/ScanBarcode.vue');

export default {
  components: {
    BCard,
    BFormTextarea,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    BBadge,
    BCardText,
    CategoryModal,
    ScanBarcode,
  },
  data() {
    return {
      categoryFilter: {
        name: '',
        id: '',
      },
      isBarCodeStep: false,
      showTables: false,
      loading: true,
      items: [],
      ItemId: null,
      employee_id: '',
      patient_card_id: '',
      date: '',
      description: '',
      editableQuantities: {},

      stockoutForm: {
        item_id: '',
        warehouse_id: '',
        batch_no: '',
        balance_id: '',
        expiry_date: '',
        quantity: '',
        unit_price: '',
      },
      itemsCloumns: [
        { key: 'item.name', label: this.$t('common.name'), sortable: true },
        {
          key: 'category.name',
          label: this.$t('warehouse.one-category'),
          sortable: true,
        },
        {
          key: 'warehouse.name',
          label: this.$t('warehouse.one-warehouse'),
          sortable: true,
        },
        {
          key: 'batch_no',
          label: this.$t('warehouse.batch-no'),
          sortable: true,
        },
        {
          key: 'expiry_date',
          label: this.$t('warehouse.exp-date'),
          sortable: true,
        },
        {
          key: 'quantity',
          label: this.$t('warehouse.quantity'),
          sortable: true,
        },
        {
          key: 'changeable-quantity',
          label: this.$t('warehouse.change-quantity'),
          sortable: true,
        },
        {
          key: 'unit_price',
          label: this.$t('warehouse.price'),
          sortable: true,
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      tableColumns: [
        { key: 'item_id.', label: this.$t('common.name'), sortable: true },
        {
          key: 'warehouse_id',
          label: this.$t('warehouse.one-warehouse'),
          sortable: true,
        },
        {
          key: 'batch_no',
          label: this.$t('warehouse.batch-no'),
          sortable: true,
        },
        {
          key: 'quantity',
          label: this.$t('warehouse.quantity'),
          sortable: true,
        },
        {
          key: 'unit_price',
          label: this.$t('warehouse.price'),
          sortable: true,
        },
        {
          key: 'expiry_date',
          label: this.$t('warehouse.exp-date'),
          sortable: true,
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      stockouts: [],
      params: {
        form: {},
        path: '',
      },
    };
  },

  computed: {
    otherItemsQuery() {
      if (this.categoryFilter.id) {
        return `filter[category_id]=${this.categoryFilter.id}`;
      }
    },
    otherQuery() {
      if (this.stockoutForm.item_id) {
        return `filter[item_id]=${this.stockoutForm.item_id}&include=item,category,warehouse`;
      }
    },
  },
  methods: {
    assignCategory(v) {
      this.categoryFilter = v;
    },
    saveItem(item) {
      this.itemId = item;
    },
    addToStockOuts(item) {
      item.expiry_date = this.formatExpDate(item.expiry_date);
      item.item_id = item.item.name;
      item.warehouse_id = item.warehouse.name;
      item.batch_no = item.batch_no;
      item.balance_id = item.id;
      item.barcode = item.barcode;
      const stockoutItem = {
        ...item,
        quantity: this.editableQuantities[item.id], // Use editable quantity
      };
      this.stockouts.push(stockoutItem);
    },
    async addToItemsList(barcode) {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/balance?filter[barcode]=${barcode}&sort=expiry_date&include=category,item,warehouse`;

      await this.getList(url);

      this.items = this.all_data.data;
      this.items.forEach((item) => {
        this.$set(this.editableQuantities, item.id, item.quantity);
      });
      this.loading = false;
      this.isBarCodeStep = false;
      this.showTables = true;
    },

    getBadgeVariant(date) {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const itemDate = new Date(date);
      const itemMonth = itemDate.getMonth();
      const itemYear = itemDate.getFullYear();

      return itemMonth === currentMonth && itemYear === currentYear
        ? 'danger'
        : 'success';
    },
    removeItem(item) {
      this.stockouts = this.stockouts.filter((stokout) => stokout !== item);
    },
    showScanner() {
      (this.isBarCodeStep = true), (this.showTables = false);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1); // getMonth() is zero-based
      let day = '' + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    async changeBalanceId() {
      this.loading = true;
      let url = `/balance?&filter[id]=${this.stockoutForm.balance_id}&include=item,category,warehouse`;

      await this.getList(url);
      this.currentBalance = this.all_data.data[0];
      this.stockoutForm.quantity = this.currentBalance.quantity;
      this.stockoutForm.warehouse_id = this.currentBalance.warehouse_id;
      this.stockoutForm.expiry_date = this.currentBalance.expiry_date;
      this.stockoutForm.unit_price = this.currentBalance.unit_price;
      this.loading = false;
    },

    submitItem() {
      this.date = this.formatExpDate(this.date);
      this.stockouts = this.stockouts.map((stock) => ({
        quantity: stock.quantity,
        price: stock.unit_price,
        balance_id: stock.balance_id,
        barcode: stock.barcode,
      }));

      (this.params.form = {
        employee_id: this.employee_id,
        patient_card_id: this.patient_card_id,
        date: this.date,
        description: this.description,
        stockouts: this.stockouts,
      }),
        (this.params.path = `/stockout`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.$router.push({
              name: `${
                this.$route.name.includes('pharmacy')
                  ? 'pharmacy-stockout'
                  : 'stockout'
              }`,
            });

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Created',
                variant: 'success',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.stockouts = [];

              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
